import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { games } from '@/mocks/games';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';

const featuredGames = games.filter((g) => g.featured);
const latestArticles = articles.slice(0, 3);

const gameImages: Record<string, string> = {
  'game-shadow-legend': 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20anime%20style%20game%20artwork%20with%20mysterious%20castle%20and%20warrior%20character%2C%20warm%20torch%20lighting%2C%20atmospheric%20shadows%2C%20professional%20illustration%20style%2C%20orange%20and%20amber%20color%20palette%2C%20cinematic%20composition%20on%20dark%20background&width=600&height=400&seq=game-shadow-legend&orientation=landscape',
  'game-sakura-promise': 'https://readdy.ai/api/search-image?query=Romantic%20anime%20school%20scene%20with%20cherry%20blossoms%2C%20soft%20warm%20sunset%20lighting%2C%20beautiful%20character%20design%2C%20nostalgic%20atmosphere%2C%20clean%20illustration%20style%2C%20warm%20orange%20and%20pink%20tones%20on%20gentle%20background&width=600&height=400&seq=game-sakura-promise&orientation=landscape',
  'game-kingdom-warfare': 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20kingdom%20scene%20with%20medieval%20castle%20and%20battlefield%2C%20warm%20golden%20lighting%2C%20strategy%20game%20artwork%2C%20detailed%20illustration%20style%2C%20rich%20amber%20and%20bronze%20color%20palette%2C%20cinematic%20composition%20on%20dark%20background&width=600&height=400&seq=game-kingdom-warfare&orientation=landscape',
  'game-mobile-girlfriend': 'https://readdy.ai/api/search-image?query=Cute%20anime%20dating%20simulation%20game%20art%20with%20smartphone%20interface%2C%20warm%20soft%20lighting%2C%20modern%20clean%20design%2C%20romantic%20atmosphere%2C%20mobile%20game%20style%2C%20soft%20orange%20and%20peach%20tones%20on%20clean%20background&width=600&height=400&seq=game-mobile-girlfriend&orientation=landscape',
  'game-neon-city': 'https://readdy.ai/api/search-image?query=Cyberpunk%20cityscape%20anime%20art%20with%20neon%20lights%20and%20mystery%20atmosphere%2C%20warm%20amber%20and%20orange%20neon%20accents%2C%20futuristic%20urban%20scene%2C%20noir%20style%20illustration%2C%20cinematic%20composition%20on%20dark%20background&width=600&height=400&seq=game-neon-city&orientation=landscape',
};

const articleImages: Record<string, string> = {
  'article-best-2025': 'https://readdy.ai/api/search-image?query=Gaming%20awards%20and%20trophy%20illustration%20with%20warm%20ambient%20lighting%2C%20minimalist%20editorial%20design%2C%20soft%20gradient%20background%2C%20modern%20magazine%20style%2C%20golden%20orange%20and%20neutral%20tones%2C%20clean%20professional%20composition&width=600&height=400&seq=article-best-2025&orientation=landscape',
  'article-safe-guide': 'https://readdy.ai/api/search-image?query=Digital%20security%20and%20shield%20concept%20illustration%2C%20warm%20protective%20glow%2C%20minimalist%20tech%20design%2C%20soft%20gradient%20background%2C%20modern%20editorial%20style%2C%20orange%20and%20warm%20neutral%20tones%2C%20clean%20composition&width=600&height=400&seq=article-safe-guide&orientation=landscape',
  'article-mobile-guide': 'https://readdy.ai/api/search-image?query=Smartphone%20gaming%20illustration%20with%20warm%20soft%20lighting%2C%20modern%20mobile%20game%20aesthetic%2C%20minimalist%20editorial%20design%2C%20clean%20gradient%20background%2C%20orange%20and%20warm%20tones%2C%20professional%20composition&width=600&height=400&seq=article-mobile-guide&orientation=landscape',
};

const faqs = [
  {
    q: '黄游下载安全吗？如何确保下载资源无毒？',
    a: '我们平台所有黄游下载资源均经过多重安全检测，包括杀毒扫描和行为分析。每款游戏在上架前都会通过严格的安全审核流程，确保玩家下载的游戏文件安全无毒。同时，我们定期更新安全检测引擎，保障下载安全性。',
  },
  {
    q: '黄游下载需要注册账号吗？',
    a: '不需要！我们的平台支持一键下载，无需注册任何账号。只需选择您喜欢的游戏，点击下载按钮即可获取资源。我们致力于提供最便捷的黄游下载体验。',
  },
  {
    q: '手机黄游下载支持哪些平台？',
    a: '我们的手机黄游下载资源支持安卓（Android）和iOS双平台。每款手机游戏都会明确标注兼容的系统版本要求，确保您能够顺利安装和运行。',
  },
  {
    q: '黄游下载速度慢怎么办？',
    a: '我们提供多个下载节点，系统会自动为您选择最优节点。如果遇到下载速度慢的情况，可以尝试切换下载线路。同时建议检查本地网络状态，确保网络连接稳定。',
  },
  {
    q: 'PC成人游戏下载的配置要求高吗？',
    a: '我们提供的PC成人游戏下载资源覆盖各种配置需求。从轻量级的视觉小说到高画质的开放世界RPG，每款游戏都会明确标注最低和推荐配置要求，您可以根据自己的电脑配置选择合适的游戏。',
  },
];

const stats = [
  { label: '游戏资源', value: '500+' },
  { label: '累计下载', value: '3,200,000+' },
  { label: '活跃用户', value: '150,000+' },
  { label: '安全认证', value: '100%' },
];

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '黄游下载',
  url: 'https://huangyou-download.com',
  description: '正版成人游戏资源安全获取平台。提供安全、快速、正版黄游下载服务。',
  email: 'contact@huangyou-download.com',
  knowsAbout: ['成人游戏下载', '黄游下载', '手机黄游下载', 'PC成人游戏下载'],
};

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '黄游下载',
  url: 'https://huangyou-download.com',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://huangyou-download.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.a,
    },
  })),
};

export default function Home() {
  useEffect(() => {
    document.title = '黄游下载 - 正版成人游戏资源安全获取平台 | 黄游下载专属频道';
  }, []);

  const combinedSchema = [orgSchema, webSiteSchema, faqSchema];

  return (
    <>
      <SEOHead
        title="黄游下载 - 正版成人游戏资源安全获取平台"
        description="黄游下载专属频道，提供安全、快速、正版成人游戏下载服务。精选高质量黄游下载资源，支持多平台兼容，一键下载无需注册，畅享优质成人游戏体验。"
        keywords="黄游下载,成人游戏下载,黄游下载安全,手机黄游下载,黄游下载合集,PC成人游戏下载,黄游资源下载"
      />
      <script type="application/ld+json">{JSON.stringify(combinedSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20gaming%20atmosphere%20with%20soft%20neon%20accents%20in%20warm%20orange%20and%20amber%20tones%2C%20abstract%20digital%20art%20style%2C%20mysterious%20ambient%20lighting%20with%20geometric%20shapes%2C%20modern%20gaming%20aesthetic%2C%20cinematic%20composition%2C%20warm%20color%20palette%20with%20dark%20backgrounds&width=1920&height=800&seq=hero-bg-main&orientation=landscape"
              alt="黄游下载 - 正版成人游戏资源安全获取平台"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
            <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 leading-tight">
                黄游下载
              </h1>
              <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed">
                正版成人游戏资源安全获取平台。精选高质量黄游下载资源，安全快速，多平台兼容，一键下载无需注册，畅享优质成人游戏体验。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/rpg"
                  className="px-6 py-3 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  浏览游戏
                </Link>
                <Link
                  to="/article/best-adult-games-2025-top10"
                  className="px-6 py-3 text-sm font-medium rounded-full border border-white/30 text-white hover:bg-white/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  查看推荐
                </Link>
              </div>
            </div>
          </section>

          {/* Stats Section */}
          <section className="py-10 md:py-14 bg-background-100">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
                {stats.map((stat, i) => (
                  <div key={i} className="text-center">
                    <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500 mb-1">
                      {stat.value}
                    </div>
                    <div className="text-sm text-foreground-600">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="py-12 md:py-16">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="text-center mb-8 md:mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                  游戏分类
                </h2>
                <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
                  多种游戏类型分类导航，快速找到你喜欢的黄游下载资源
                </p>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="group flex flex-col items-center gap-3 p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
                  >
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100/80 group-hover:bg-accent-200 transition-colors duration-200">
                      <i className={`${cat.icon} text-xl text-accent-700`}></i>
                    </div>
                    <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                      {cat.name}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Featured Games */}
          <section className="py-12 md:py-16 bg-background-100">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="flex items-center justify-between mb-8 md:mb-10">
                <div>
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
                    热门推荐
                  </h2>
                  <p className="text-sm text-foreground-600">精选高质量黄游下载资源</p>
                </div>
                <Link
                  to="/category/rpg"
                  className="text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap flex items-center gap-1 cursor-pointer"
                >
                  查看全部
                  <span className="w-3 h-3 flex items-center justify-center"><i className="ri-arrow-right-line text-xs"></i></span>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {featuredGames.map((game) => (
                  <Link
                    key={game.id}
                    to={`/category/${game.category}`}
                    className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
                  >
                    <div className="relative w-full h-48 overflow-hidden">
                      <img
                        src={gameImages[game.imageSeq] || gameImages['game-shadow-legend']}
                        alt={game.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                      />
                      <div className="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium">
                        {game.rating}
                      </div>
                    </div>
                    <div className="p-4">
                      <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                        {game.title}
                      </h3>
                      <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">{game.description}</p>
                      <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/60">
                        <span className="text-xs text-foreground-500 flex items-center gap-1">
                          <span className="w-3 h-3 flex items-center justify-center"><i className="ri-download-line text-xs"></i></span>
                          {game.downloads}
                        </span>
                        <span className="text-xs text-foreground-500">{game.platform}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Latest Articles */}
          <section className="py-12 md:py-16">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="flex items-center justify-between mb-8 md:mb-10">
                <div>
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
                    最新资讯
                  </h2>
                  <p className="text-sm text-foreground-600">黄游下载攻略与游戏推荐</p>
                </div>
                <Link
                  to="/article/best-adult-games-2025-top10"
                  className="text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap flex items-center gap-1 cursor-pointer"
                >
                  更多文章
                  <span className="w-3 h-3 flex items-center justify-center"><i className="ri-arrow-right-line text-xs"></i></span>
                </Link>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {latestArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
                  >
                    <div className="relative w-full h-44 overflow-hidden">
                      <img
                        src={articleImages[article.imageSeq] || articleImages['article-best-2025']}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                      />
                    </div>
                    <div className="p-4">
                      <div className="flex items-center gap-4 text-xs text-foreground-500 mb-2">
                        <span>{article.date}</span>
                        <span>{article.readTime}</span>
                      </div>
                      <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                        {article.title}
                      </h3>
                      <p className="text-xs text-foreground-500 mt-2 line-clamp-2">{article.summary}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="py-12 md:py-16 bg-background-100">
            <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                立即开始你的黄游下载之旅
              </h2>
              <p className="text-sm md:text-base text-foreground-600 mb-6 max-w-lg mx-auto">
                500+精选成人游戏资源，安全快速下载，无需注册，即刻畅玩
              </p>
              <Link
                to="/category/rpg"
                className="inline-flex px-6 py-3 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                探索游戏库
              </Link>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="py-12 md:py-16">
            <div className="max-w-3xl mx-auto px-4 md:px-6">
              <div className="text-center mb-8 md:mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                  常见问题
                </h2>
                <p className="text-sm text-foreground-600">关于黄游下载的常见疑问解答</p>
              </div>
              <div className="space-y-3">
                {faqs.map((faq, i) => (
                  <details key={i} className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden cursor-pointer">
                    <summary className="flex items-center justify-between p-4 md:p-5 text-sm md:text-base font-medium text-foreground-900 list-none">
                      {faq.q}
                      <span className="w-5 h-5 flex items-center justify-center group-open:rotate-180 transition-transform duration-200 ml-3 shrink-0">
                        <i className="ri-arrow-down-s-line"></i>
                      </span>
                    </summary>
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}